// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"ee54061d","464":"5600cafc","787":"5128b469"}[chunkId] + ".chunk.js";
};